import React, { useEffect, useState, useContext } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import ProcessBoardThree from '../components/process/ProcessBoardThree';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import InfosPoste from '../components/position/InfosPoste';
import { DynamicBreadcrumb } from '../components/utils/Breadcrumb';
import { ApiContext } from '../App';
import PositionDocuments from '../components/position/PositionDocuments';
import PositionTasks from '../components/position/PositionTasks';


const PositionDetail = () => {
  const API = useContext(ApiContext);
  const { id } = useParams();
  const navigate = useNavigate();
  const [position, setPosition] = useState(null);

  useEffect(() => {
    const fetchPosition = async () => {
      try {
        const response = await API.get(`/api/positions/${id}`);
        setPosition(response.data);
      } catch (error) {
        console.error('Error fetching position:', error);
      }
    };
    fetchPosition();
  }, [id]);

  const handleUpdate = (updatedData) => {
    API
      .put(`/api/positions/${id}`, updatedData)
      .then((response) => setPosition(response.data))
      .catch((error) => console.error('Error updating position:', error));
  };


  const handleDelete = () => {
    API
      .delete(`/api/positions/${id}`)
      .then(() => navigate('/process-rh'))
      .catch((error) => console.error('Error deleting position:', error));
  };

  if (!position) return <div></div>;

  return (
    <div className="p-4 sm:p-6 lg:p-10 mx-auto bg-gray-100 min-h-screen pt-16">
      {/* Breadcrumb */}
      <div className='pt-10'>
        <DynamicBreadcrumb 
          baseItems={[
            { label: 'Dashboard', href: '/app', icon: 'bi-house' },
            { label: 'Recrutement', href: '/process-rh', icon: 'bi-briefcase' }
          ]} 
          currentItem={{ name: position?.title || 'Position' }}
        />
      </div>
      
      
      <Tabs defaultActiveKey="candidats" id="position-tabs" className="mb-3 bg-gray-100 ">
        <Tab eventKey="candidats" title="Candidats" className=''>
          <ProcessBoardThree positionId={id} />
          <PositionTasks positionId={id} />
        </Tab>
        <Tab eventKey="Infos Poste" title="Infos Poste" className=''>
          <InfosPoste position={position} onUpdate={handleUpdate} onDelete={handleDelete} />
        </Tab>
        <Tab eventKey="documents" title="Documents" className=''>
          <PositionDocuments positionId={id} />
        </Tab>
      </Tabs>
    </div>
  );
};

export default PositionDetail;